import {translateText} from "./index";

const objs = {
    AR:{
        cedula:"Documento Nacional de Identidad, DNI",
        rnc:"Código Único de Identificación Tributaria, CUIT",
        provincia: "Provincia",
        ncf:"NCF"
    },
    ES:{
        cedula:"Documento Nacional de Identidad, DNI",
        rnc:"Código de Identificación Fiscal, CIF",
        provincia: "Provincia",
        ncf:"NCF"
    },
    PE:{
        cedula:"Documento Nacional de Identidad, DNI",
        rnc:"Registro Único de Contribuyentes, RUC",
        provincia: "Provincia",
        ncf:"NCF"
    },
    BO:{
        cedula:"Cédula de Identidad, CI",
        rnc:"Número de Identificación Tributaria, NIT",
        provincia: "Provincia",
        ncf:"NCF"
    },
    CL:{
        cedula:"Cédula de Identidad, CI",
        rnc:"Rol Único Tributario, RUT",
        provincia: "Provincia",
        ncf:"NCF"
    },
    CR:{
        cedula:"Cédula de Identidad, CI",
        rnc:"Número de Identificación Tributaria Especial, NITE",
        provincia: "Provincia",
        ncf:"NCF"
    },
    NI:{
        cedula:"Cédula de Identidad, CI",
        rnc:"Registro Único de Contribuyentes, RUC",
        provincia: "Provincia",
        ncf:"NCF"
    },
    UY:{
        cedula:"Cédula de Identidad, CI",
        rnc:"Registro Único Tributario, RUT",
        provincia: "Provincia",
        ncf:"NCF"
    },
    VE:{
        cedula:"Cédula de Identidad, CI",
        rnc:"Registro de Información Fiscal, RIF",
        provincia: "Provincia",
        ncf:"NCF"
    },
    CO:{
        cedula:"Cédula de Ciudadanía, CC",
        rnc:"Número de Identificación Tributaria, NIT",
        provincia: "Provincia",
        ncf:"NCF"

    },
    EC:{
        cedula:"Cédula de Ciudadanía, CC",
        rnc:"Registro Único de Contribuyentes, RUC",
        provincia: "Provincia",
        ncf:"NCF"
    },
    SV:{
        cedula:"Doc. Único de Identidad, DUI",
        rnc:"Número de Identificación Tributaria, NIT",
        provincia: "Provincia",
        ncf:"NCF"
    },
    GT:{
        cedula:"Doc. Personal de Identificación, DPI",
        rnc: "Registro Tributario Unificado, RTU",
        provincia: "Provincia",
        ncf:"NCF"
    },
    HN:{
        cedula:"Documento Nacional de Identidad, DNI",
        // cedula:"Tarjeta de Identidad, TDI",
        rnc: "Registro Tributario Nacional, RTN",
        provincia: "Departamento",
        ncf:"Número Factura"
    },
    MX:{
        cedula:"Credencial de Elector, CURP",
        rnc:"Registro Federal de Contribuyentes,RFC",
        provincia: "Provincia",
        ncf:"NCF"
    },
    PA:{
        cedula:"Cédula de Identidad Personal, CIP",
        rnc: "Número de Identificación Tributaria, NIT",
        provincia: "Provincia",
        ncf:"NCF"
    },
    PY:{
        cedula:"Cédula de Identidad civil, CIC/CI",
        rnc:"Registro Único de Contribuyentes, RUC",
        provincia: "Provincia",
        ncf:"NCF"
    },
    PR:{
        cedula:"Identificación, ID",
        rnc:"Numeros de Identificacion del Contribuyente, TIN",
        provincia: "Provincia",
        ncf:"NCF"
    },
    DO:{
        cedula:"Cédula de Identidad y Electoral, Cédula",
        rnc:"Registro Nacional del Contribuyente, RNC",
        provincia: "Provincia",
        ncf:"NCF (Comprobante Fiscal)"
    }
}

export default function geoString(str: "rnc"|"cedula"|"provincia"|"ncf",acronimo?: boolean){
    const countryCode = process.env.REACT_APP_NAME?.toLowerCase() === "vivirmax" ? "DO" : "HN";

    let item = objs[countryCode];

    if(!item) return translateText(str);

    let cedula = item.cedula.split(",");
    let rnc = item.rnc.split(",");



    switch (str){
        case "cedula":
            return  cedula[acronimo?1:0];
        case "rnc":
            return rnc[acronimo?1:0];
        case "provincia":
            return item.provincia;
        case "ncf":
            return item.ncf;
        default:
            return translateText(str);
    }
}
